export const RESIZE_DEBOUNCE = 33;
export const AUTOSCROLL_DEBOUNCE = 800;
export const PRODUCTS_LIST_FETCHING_DEBOUNCE = 220;
export const MODAL_RESIZE_DEBOUNCE = 30;
export const CART_FOOTER_DEBOUNCE = 210;
export const COUNTER_CLICK_DEBOUNCE = 300;

export const TOOLTIP_HOVER_INTENT_DEBOUNCE = 50;
export const TOOLTIP_HOVER_CLOSE_DEBOUNCE = 250;
export const SEARCH_SCROLL_DEBOUNCE = 200;

export const VIDEO_AUTOPLAY_DEBOUNCE = 30;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/debounce-delays.js